import type {
  EventPrefix,
  GoogleTagManagerEventDetails,
} from "@/features/analytics/models";
import {
  EVENT_PREFIX,
  GOOGLE_TAG_MANAGER_EVENT,
} from "@/features/analytics/models";
import { triggerGoogleTagManagerTracking } from "@/features/analytics/triggers";
import { categoriesToGoogleTagManagerProducts } from "@/features/analytics/utils";
import type { CategoryWithSelectedProduct } from "@/features/products/models";
import { calculateTotal } from "@/features/products/utils";
import { CURRENCY } from "@/shared/models";
import { triggerCustomerIoProductsSelected } from "../triggers";

interface TrackProductsSelectedParams {
  selectedCategories: CategoryWithSelectedProduct[];
  userId?: string;
  eventPrefix?: EventPrefix;
}

export const trackProductsSelected = ({
  selectedCategories,
  userId,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackProductsSelectedParams) => {
  triggerCustomerIoProductsSelected({
    selectedCategories,
    userId,
    eventPrefix,
  });

  triggerGoogleTagManagerTracking<GoogleTagManagerEventDetails>({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.PRODUCT_SELECTED}`,
    ecommerce: {
      currency: CURRENCY.USD,
      value: calculateTotal(selectedCategories),
      items: categoriesToGoogleTagManagerProducts(selectedCategories),
    },
  });
};
